export class ClauseType {
  static HONORAIRE = "honoraire";
  static SOLIDARITE = "solidarite";
  static SOUSLOC = "sousloc";
  static SOUSLOCPRO = "souslocpro";
  static VETUSTE = "vetuste";
  static SANS_RENOUVELLEMENT = "sans_renouvellement";
}
